import React from 'react';
import styles from './Wall.module.css';

interface WallProps {
  children: React.ReactNode;
}

const Wall: React.FC<WallProps> = ({ children }) => (
  <div className={styles.wall}>{children}</div>
);

export default Wall;
